<template>
    <sub-page class="m-resDetail" :title="resourceData.name">
        <div class="container">
            <!-- 文档 -->
            <iframe v-if="mediaType === 8" class="doc" :src="sectionDocSrc" frameborder="0"></iframe>

            <!-- 视频 -->
            <div class="player" v-if="mediaType === 10">
                <video-player class="video-player vjs-custom-skin"
                              ref="videoPlayer"
                              :playsinline="true"
                              :options="playerOptions"
                >
                </video-player>
            </div>

            <!-- 音频 -->
            <div class="player" v-if="mediaType === 11">
                <div class="video-player vjs-custom-skin">
                    <div id="vjs_video_4669"
                         class="video-js vjs_video_4669-dimensions vjs-fluid vjs-controls-enabled vjs-workinghover vjs-v7 vjs-has-started"
                         :class="isPlaying?'vjs-playing':'vjs-paused'"
                         lang="zh-cn" role="region" aria-label="音频播放器">
                        <img class="vjs-tech" id="vjs_video_4669_html5_api"
                             src="../../assets/images/course/audio_bg.png" @click="pause"/>

                        <button class="vjs-big-play-button" type="button" :title="$t('res.playAudio')" aria-disabled="false"
                                @click="play">
                            <span aria-hidden="true" class="vjs-icon-placeholder"></span>
                            <span class="vjs-control-text" aria-live="polite">{{ $t('res.playAudio') }}</span>
                        </button>
                        <div class="aplayer-control-bar">
                            <aplayer style="margin:0" ref="audioPlayer" :music="media" @play="play"
                                     @pause="pause"/>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </sub-page>
</template>

<script>
import Aplayer from 'vue-aplayer'
import VideoPlayer from "@/components/VideoPlayer"

Aplayer.disableVersionBadge = true

export default {
    components: {
        Aplayer,
        VideoPlayer,
    },

    data() {
        return {
            resourceData: {},
            isPlaying: false,
            media: null,
            sectionDocSrc: '',
            mediaType: 0,
            playerOptions: {
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: this.$i18n.locale,
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                    type: 'application/x-mpegURL',
                    // type: videoUrl.toLowerCase().split('.').splice(-1) == 'mp4'?'video/mp4':'application/x-mpegURL',
                    // src: 'https://vodcdn.alicdn.com/oss/taobao-ugc/e6fb60eae8594f9e812233489bfa2732/1476578718/video.mp4',//你的m3u8地址（必填）
                    //    src: 'videoUrl',
                    src: 'https://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8',
                    withCredentials: false
                }],
                // poster: "http://i5.hexun.com/2017-10-30/191428422.jpg", //你的封面地址
                width: document.documentElement.clientWidth,
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                //controlBar: {
                //  timeDivider: true,
                //  durationDisplay: true,
                //  remainingTimeDisplay: false,
                //  fullscreenToggle: true  //全屏按钮
                //}
                html5: {hls: {withCredentials: false}},
                //    flash: {swf: '//path/to/videojs.swf'}
            },
        }
    },

    computed: {
        player() {
            return this.$refs.videoPlayer.player
        },
    },

    mounted() {
        let id = this.$route.params.id

        this.$api.getResourceDetail(id).then(res => {
            let data = this.resourceData = res.package

            this.playResource(data)
        })
    },

    methods: {
        playResource(data) {
            if (data.type === 10) {
                // 视频
                setTimeout(() => {
                    this.$set(this.playerOptions.sources, 0, {
                        type: data.entity.url.toLowerCase().split('.').splice(-1) == 'mp4' ? 'video/mp4' : 'application/x-mpegURL',
                        src: data.entity.url,
                    })

                    this.player.muted(false)
                }, 300)
                this.mediaType = data.type;

            } else if (data.type === 8) {
                // 文档
                this.sectionDocSrc = encodeURI(data.entity.url);
                this.mediaType = data.type;

            } else if (data.type === 11) {
                // 音频
                this.mediaType = data.type;
                this.isPlaying = false;

                this.media = {
                    title: data.name,
                    artist: data.creatorName,
                    src: data.entity.url,
                    pic: require('../../assets/images/course/play_bg.jpg')
                }
            }
        },

        play() {
            this.$nextTick(() => {
                this.isPlaying = true;
                this.$refs.audioPlayer.play();
            })
        },
        pause() {
            this.$nextTick(() => {
                this.isPlaying = false;
                this.$refs.audioPlayer.pause();
            })
        },
    },
}
</script>

<style lang="scss">
.m-resDetail {
    .container {
        background-color: #f9f9f9;
        min-height: 100%;

        .doc {
            width: 100%;
            height: 100%;
        }

        .aplayer-control-bar {
            position: absolute;
            width: 100%;
            bottom: 0;
            right: 0;
            left: 0;

            .aplayer {
                .aplayer-controller .aplayer-time .aplayer-icon.inactive {
                    display: none;
                }
            }

        }
    }

    .el-card {
        display: flex;
        flex-direction: column;
        height: 100%;

        .el-card__header {
            flex-shrink: 0;
        }

        .el-card__body {
            flex: 1;
            padding: 0;

            .container, .player, .player > div {
                height: 100%;
            }
        }
    }

    .vjs-fluid {
        height: 100%;
        padding-top: 0;
    }

}
</style>
